import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "empty-channel py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "icon-wrapper text-center" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-check" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("h5", null, "Stripe Account was successfully Setup!", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, "Your stripe Account was successfully Setup!", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, "Just wait convorally arrive at home", -1)
const _hoisted_7 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode("a", {
            href: "javascript:void(0)",
            class: "btn default-btn outline",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToDashboard && _ctx.redirectToDashboard(...args)))
          }, " Redirect to Dashboard")
        ])
      ])
    ])
  ]))
}